import { http, createConfig } from "wagmi";
import { base } from "wagmi/chains";
import { farcasterMiniApp as miniAppConnector } from "@farcaster/miniapp-wagmi-connector";

export const config = createConfig({
  chains: [base],
  transports: {
    [base.id]: http(
      "https://base-mainnet.g.alchemy.com/v2/5Pv0vyGJF3DqIDB4PqUQS"
    ),
  },
  connectors: [miniAppConnector()],
});
